import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M9 4v16","key":"svg-1"}],["path",{"d":"M14 10l2 2l-2 2","key":"svg-2"}]]

const IconLayoutSidebarLeftExpand = createReactComponent('outline', 'layout-sidebar-left-expand', 'LayoutSidebarLeftExpand', __iconNode);

export default IconLayoutSidebarLeftExpand;